import PropertyPanel from '../widgets/PropertyPanel.js';

/**
 * ColorPropertyPanel - UI for color material properties
 */
export default class ColorPropertyPanel extends PropertyPanel {
  /**
   * Render the color property panel
   * @param {Object} initialData - Initial property values
   */
  render(initialData = {}) {
    this.clear();

    // Color picker
    const colorPicker = this.addColorPicker('Color', initialData.color || '#3498db');
    colorPicker.addEventListener('input', () => {
      if (this.onChange) this.onChange();
    });
    this.controls.colorPicker = colorPicker;

    // Opacity slider
    const opacitySlider = this.addSlider(
      'Opacity',
      0,
      1,
      0.01,
      initialData.opacity !== undefined ? initialData.opacity : 1,
      (val) => {
        if (this.onOpacityChange) this.onOpacityChange(val);
        if (this.onChange) this.onChange();
      }
    );
    this.controls.opacitySlider = opacitySlider;
  }

  /**
   * Get current property values
   * @returns {Object} Current values
   */
  getData() {
    return {
      type: 'color',
      color: this.controls.colorPicker.value,
      opacity: parseFloat(this.controls.opacitySlider.slider.value)
    };
  }

  /**
   * Set property values
   * @param {Object} data - Property values
   */
  setData(data) {
    if (data.color) {
      this.controls.colorPicker.value = data.color;
    }
    if (data.opacity !== undefined) {
      this.controls.opacitySlider.slider.value = data.opacity;
      this.controls.opacitySlider.valueInput.value = data.opacity;
    }
  }
}
